'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { useQueryState } from 'nuqs';
import { useCallback } from 'react';
import { granularityParser, metricParser } from '@/modules/finances/lib/breakdown-chart-search-params';
import { BasicSelect } from '@/modules/shared/components/basic-select/basic-select';
import { FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { GRANULARITY_OPTIONS, METRIC_OPTIONS } from '../../types';
import { BreakdownGranularitySelectDrawer, BreakdownMetricSelectDrawer } from './filter-metric-breakdown-chart';
function FilterChart() {
  const $ = _c(38);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = metricParser.withOptions({
      shallow: false
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [metric, setMetric] = useQueryState("metric", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = granularityParser.withOptions({
      shallow: false
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [granularity, setGranularity] = useQueryState("granularity", t1);
  let t2;
  if ($[2] !== setGranularity || $[3] !== setMetric) {
    t2 = () => {
      setMetric(null);
      setGranularity(null);
    };
    $[2] = setGranularity;
    $[3] = setMetric;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onReset = t2;
  let t3;
  if ($[5] !== onReset) {
    t3 = <Button variant="ghost" className="text-muted-foreground" onClick={onReset}>Reset Filters</Button>;
    $[5] = onReset;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `metric-${metric}`;
  let t5;
  if ($[7] !== setMetric) {
    t5 = value => {
      setMetric(value as METRIC_OPTIONS);
    };
    $[7] = setMetric;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Object.values(METRIC_OPTIONS);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== metric || $[11] !== t4 || $[12] !== t5) {
    t7 = <BasicSelect key={t4} value={metric} label="Metric" onValueChange={t5} options={t6} placeholder="Budget" />;
    $[10] = metric;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `granularity-${granularity}`;
  let t9;
  if ($[14] !== setGranularity) {
    t9 = value_0 => {
      setGranularity(value_0 as GRANULARITY_OPTIONS);
    };
    $[14] = setGranularity;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = Object.values(GRANULARITY_OPTIONS);
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== granularity || $[18] !== t8 || $[19] !== t9) {
    t11 = <BasicSelect key={t8} label="Granularity" value={granularity} onValueChange={t9} options={t10} placeholder="Monthly" />;
    $[17] = granularity;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t3 || $[23] !== t7) {
    t12 = <div className="hidden items-center gap-4 md:flex">{t3}{t7}{t11}</div>;
    $[21] = t11;
    $[22] = t3;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== metric || $[26] !== setMetric) {
    t13 = <BreakdownMetricSelectDrawer metric={metric} setMetric={setMetric} />;
    $[25] = metric;
    $[26] = setMetric;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== granularity || $[29] !== setGranularity) {
    t14 = <BreakdownGranularitySelectDrawer granularity={granularity} setGranularity={setGranularity} />;
    $[28] = granularity;
    $[29] = setGranularity;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== onReset || $[32] !== t13 || $[33] !== t14) {
    t15 = <div className="flex items-center gap-4 md:hidden"><FilterDrawer onReset={onReset}>{t13}{t14}</FilterDrawer></div>;
    $[31] = onReset;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t12 || $[36] !== t15) {
    t16 = <div className="row flex gap-4">{t12}{t15}</div>;
    $[35] = t12;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
export { FilterChart };